import CategoryViewItem from "component/categories-viewer/CategoryViewItem";
import VizSensor from "component/design-system/VizSensor";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import ServiceSection from "modules/components/ServiceSection";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import styles from "./shop-wheel-tire.module.scss";

const ShopWheelTire = () => {
  const { t } = useTranslation("home");
  const t0 = "wheels & tires";

  const sectionsArray = [
    {
      title: "Shop tires",
      tier1: "Tires",
      imageUrl: "shop-tires.webp",
      alt: "Shop Tires",
    },
    {
      title: "Shop tire bundles",
      tier1: "Wheels and Tires Packages",
      imageUrl: "shop-wheel-tire-brands.webp",
      alt: "Shop Tire Bundles",
    },
    {
      title: "Shop wheels",
      tier1: "Wheels",
      imageUrl: "shop-wheels.webp",
      alt: "Shop Wheels",
    },
  ];

  return (
    <VizSensor>
      <ServiceSection className={styles.service_section}>
        <PAText
          bold
          component="h2"
          fontSize={FONT_SIZE[5]}
          className="text-center m-t-0"
        >
          {t("Shop Wheels & Tires")}
        </PAText>
        {/* <Link href={href} as={asPath}> */}
        <div className={styles.shop_wheel_tire_container}>
          {sectionsArray.map((item) => (
            <div className={styles.section} key={item.imageUrl}>
              <CategoryViewItem
                categoryObj={{
                  tier0: t0,
                  tier1: item.tier1,
                }}
                className={styles.category_view_item}
              >
                <>
                  <div className={styles.shop_wheel_tire_image}>
                    <Image
                      src={`${process.env.NEXT_PUBLIC_CMS}/pubicImages/images/${item.imageUrl}`}
                      width={480}
                      height={336}
                      alt={item.alt}
                    />
                  </div>
                  <PAText underline bold>
                    {" "}
                    {item.title}
                    {" "}
                  </PAText>
                </>

              </CategoryViewItem>

            </div>
          ))}
        </div>
      </ServiceSection>
    </VizSensor>
  );
};

export default ShopWheelTire;
